// extracted by mini-css-extract-plugin
export default {"Tab":"tabs_Tab__U1jcj","Mui-selected":"tabs_Mui-selected__2Az46","Tab__content":"tabs_Tab__content__V43E2"};